import Icon from '../components/Icon';

const DifficultyStrenuous = Icon(
  'difficulty-strenuous',
  <>
    <path
      fill="var(--color-difficulty-strenuous)"
      d="M8.61 5.149c1.186-1.187 1.78-1.78 2.464-2.002a3 3 0 0 1 1.852 0c.684.222 1.277.815 2.464 2.002l3.461 3.46c1.187 1.187 1.78 1.78 2.002 2.465.196.602.196 1.25 0 1.852-.222.684-.815 1.277-2.002 2.464l-3.46 3.461c-1.187 1.187-1.78 1.78-2.465 2.002a3 3 0 0 1-1.852 0c-.684-.222-1.278-.815-2.464-2.002l-3.461-3.46c-1.187-1.187-1.78-1.78-2.002-2.465a3 3 0 0 1 0-1.852c.222-.684.815-1.278 2.002-2.464z"
    />
  </>
);

export default DifficultyStrenuous;
